import React from "react";
import { BiSmile } from "react-icons/bi";
import {
  BsEmojiFrown,
  BsEmojiSmile,
  BsEmojiNeutral,
  BsEmojiDizzy,
} from "react-icons/bs";
import "./resultsComponents.css";
import { FaRegFaceMehBlank } from "react-icons/fa6";
import * as url from "../../../../utils/url";
import axios from "../../../../axios";

import OoPopover from "../../../../components/UI/Popover/OoPopover";
import { useState } from "react";
import { useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import parse from "react-html-parser";
import { profilePicValidityCheck, Spinner } from "../../../../utils/constants";
import {
  SENTIMENT_LABEL_POSITIVE,
  SENTIMENT_LABEL_NEUTRAL,
  SENTIMENT_LABEL_NEGATIVE,
  SENTIMENT_LABEL_NEUTRAL_MIXED,
  SENTIMENT_LABEL_NEUTRAL_MIXED_DISPLAY,
  SENTIMENT_MODAL_COLUMN_QUESTION,
} from "../../../../utils/triviaResultsStrings";
import { showYou } from "../../data";
import { stripSmsBoilerplate } from "../../../../utils/stripSmsBoilerplate";
import moment from "moment";
import "../../trivvy-sentiment-modal-bwai.css";

export default function TextSentimentComponentOverall({
  data,
  totalSumOfNumResponses,
  titleAlign = "left",
  totalSentimentCounts,
  isProgress = true,
  currentTrivvy,
  user,
  blockModal,
  questionId
}) {
  const getSetimentPercent = (num) => {
    const sumCounts = totalSentimentCounts
      ? Object.values(totalSentimentCounts).reduce(
          (partialSum, a) => partialSum + a,
          0
        )
      : 0;

    if (num == 0 || sumCounts == 0) {
      return 0;
    }
    return Math.round((num / sumCounts) * 100);
  };

  let cachedSentimentPercents = null;

  const getSegmentWidth = (num) => {
    const counts = [
      totalSentimentCounts && totalSentimentCounts.POSITIVE
        ? totalSentimentCounts.POSITIVE
        : 0,
      (totalSentimentCounts && totalSentimentCounts.NEUTRAL
        ? totalSentimentCounts.NEUTRAL
        : 0) +
        (totalSentimentCounts && totalSentimentCounts.MIXED
          ? totalSentimentCounts.MIXED
          : 0),
      totalSentimentCounts && totalSentimentCounts.NEGATIVE
        ? totalSentimentCounts.NEGATIVE
        : 0,
    ];

    const total = counts.reduce((sum, c) => sum + c, 0);

    if (num === 0 || total === 0) return 0;

    if (!cachedSentimentPercents) {
      const rawPercents = counts.map((c) => (c / total) * 100);
      const rounded = rawPercents.map((p) => Math.round(p));
      const roundedSum = rounded.reduce((a, b) => a + b, 0);

      if (roundedSum === 100) {
        cachedSentimentPercents = counts.map((c, i) => ({
          count: c,
          percent: rounded[i],
        }));
      } else {
        const floored = rawPercents.map(Math.floor);
        let remainder = 100 - floored.reduce((a, b) => a + b, 0);

        const countGroups = {};
        counts.forEach((val, i) => {
          if (!countGroups[val]) countGroups[val] = [];
          countGroups[val].push(i);
        });

        const remainders = rawPercents.map((p, i) => ({
          index: i,
          remainder: p - floored[i],
          count: counts[i],
          isUnique: countGroups[counts[i]].length === 1,
        }));

        remainders.sort((a, b) => {
          if (a.isUnique !== b.isUnique) return b.isUnique - a.isUnique;
          return b.remainder - a.remainder;
        });

        for (let i = 0; i < remainder; i++) {
          floored[remainders[i].index]++;
        }

        cachedSentimentPercents = counts.map((c, i) => ({
          count: c,
          percent: floored[i],
        }));
      }
    }

    const matchIndex = cachedSentimentPercents.findIndex(
      (item) => item.count === num
    );
    if (matchIndex !== -1) {
      const { percent } = cachedSentimentPercents.splice(matchIndex, 1)[0];
      return percent;
    }

    return Math.round((num / total) * 100);
  };

  const [sentimentResponsesModal, setSentimentResponsesModal] = useState({
    open: false,
    title: "",
    data: [],
    loading: false,
  });

  const [questionsMap, setQuestionsMap] = useState();

  const consturctUserObjForExternalUser = (obj) => {
    if (obj && obj.email) {
      return {
        firstName: obj.email,
        identification: "[Email]-",
      };
    } else if (obj && obj.name) {
      const arr = obj.name.split(" ");
      return {
        identification: "[Name]-",
        firstName: arr[0],
        lastName: arr[1] || "",
      };
    } else if(obj && obj.employeeId) {
      return {
        identification: "[User ID]-",
        firstName: obj && obj.employeeId,
      };
    }  else {
      return {
        identification: "Anonymous",
        firstName:  ""
      };
    }
  };

  useEffect(() => {
    // Messaging trivvys have no questions array — skip building the map.
    if (currentTrivvy && currentTrivvy.isMessaging) {
      return;
    }

    const qIdTextMap = {};

    if (currentTrivvy && currentTrivvy.questions) {
      for (const q of currentTrivvy.questions) {
        qIdTextMap[q.question_id] = q.question_text;
      }
    }
    setQuestionsMap(qIdTextMap);
  }, []);

  const handleGetResponses = (sentiment) => {
    setSentimentResponsesModal({
      open: true,
      title: sentiment,
      data: [],
      loading: true,
    });
    const isMessaging =
      currentTrivvy && currentTrivvy.isMessaging ? true : false;

    axios
      .post(url.getResponsesForSentiments, {
        triviaId: currentTrivvy._id,
        sentiment: sentiment.toUpperCase() === "NEUTRAL" ? "NEUTRAL/MIXED" : sentiment.toUpperCase(),
        isMessaging,
      })
      .then(({ data }) => {
        const results = data.data;

        const mainData = [];

        if (isMessaging) {
          // Messaging: sentiment lives at the document level
          // (sentimentsScore.sentiment) and the comment is messagingResponse.text.
          // The first column shows the message CONTENT (messagingSubject); name
          // (the title) is only a fallback when content is absent.
          const messageContent =
            currentTrivvy && currentTrivvy.messagingSubject
              ? currentTrivvy.messagingSubject
              : currentTrivvy && currentTrivvy.name
              ? currentTrivvy.name
              : "";

          results.map((result) => {
            const sentimentsScore = result.sentimentsScore;

            const matchesSentiment =
              sentimentsScore && sentimentsScore.sentiment
                ? sentiment.toUpperCase() === "NEUTRAL"
                  ? sentimentsScore.sentiment === "NEUTRAL" ||
                    sentimentsScore.sentiment === "MIXED"
                  : sentimentsScore.sentiment === sentiment.toUpperCase()
                : false;

            if (!matchesSentiment) {
              return;
            }

            const commentText =
              result.messagingResponse && result.messagingResponse.text
                ? result.messagingResponse.text
                : "";

            const scoreKey =
              sentimentsScore && sentimentsScore.sentiment
                ? sentimentsScore.sentiment.toLowerCase()
                : sentiment.toLowerCase();

            mainData.push({
              user: result.userId
                ? result.userId
                : result.userData
                ? consturctUserObjForExternalUser(result.userData)
                : null,

              question: messageContent,
              date: result.createdOn,
              comment: stripSmsBoilerplate(commentText),
              score:
                sentimentsScore && sentimentsScore[scoreKey]
                  ? sentimentsScore[scoreKey]
                  : 0,
            });
          });
        } else {
          results.map((result) => {
            let textResponses =
              result.responses &&
              result.responses.filter(
                (x) =>
                  x.selected_answers &&
                  x.selected_answers[0] &&
                  x.selected_answers[0].text &&
                  x.textSentimentsData &&
                  (sentiment.toUpperCase() === "NEUTRAL"
                    ? (x.textSentimentsData.sentiment === "NEUTRAL" || x.textSentimentsData.sentiment === "MIXED")
                    : x.textSentimentsData.sentiment == sentiment.toUpperCase())
              );

            if (questionId) {
              textResponses = textResponses.filter(
                (x) => x.question_id == questionId
              );
            }

            for (const item of textResponses) {
              mainData.push({
                user: result.userId
                  ? result.userId
                  : result.userData
                  ? consturctUserObjForExternalUser(result.userData)
                  : null,

                question: questionsMap[item.question_id],
                date: result.createdOn,
                comment: stripSmsBoilerplate(item.selected_answers[0].text),
                score:
                  item.textSentimentsData &&
                  item.textSentimentsData[item.textSentimentsData.sentiment ? item.textSentimentsData.sentiment.toLowerCase() : sentiment.toLowerCase()],
              });
            }
          });
        }

        setSentimentResponsesModal({
          open: true,
          title: sentiment,
          data: mainData,
          loading: false,
        });
      });
  };

  const getInitials = (user) => {
    let firstName =
      user && user.firstName && user.firstName.length > 0
        ? user.firstName
        : "N";
    let lastName =
      user && user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  if (data) {
    if (isProgress) {
      const positive =
        totalSentimentCounts && totalSentimentCounts.POSITIVE
          ? totalSentimentCounts.POSITIVE
          : 0;
      const neutral =
        totalSentimentCounts && totalSentimentCounts.NEUTRAL
          ? totalSentimentCounts.NEUTRAL
          : 0;
      const mixed =
        totalSentimentCounts && totalSentimentCounts.MIXED
          ? totalSentimentCounts.MIXED
          : 0;
      const negative =
        totalSentimentCounts && totalSentimentCounts.NEGATIVE
          ? totalSentimentCounts.NEGATIVE
          : 0;

      const segments = [
        {
          name: SENTIMENT_LABEL_POSITIVE,
          percentage: getSetimentPercent(positive),
          width: getSegmentWidth(positive),
          color: "#4CB43C",
          count: positive,
        },
        {
          name: SENTIMENT_LABEL_NEUTRAL,
          percentage: getSetimentPercent(neutral + mixed),
          width: getSegmentWidth(neutral + mixed),
          color: "#FF9900",
          count: neutral + mixed,
        },
        {
          name: SENTIMENT_LABEL_NEGATIVE,
          percentage: getSetimentPercent(negative),
          width: getSegmentWidth(negative),
          color: "#F36464",
          count: negative,
        },
      ];

      const getNeturalMixedTitle = (sentiment) =>
        sentiment === SENTIMENT_LABEL_NEUTRAL
          ? SENTIMENT_LABEL_NEUTRAL_MIXED_DISPLAY
          : sentiment;

      return (
        <div>
          {sentimentResponsesModal && sentimentResponsesModal.open && (
            <Modal
              isOpen={sentimentResponsesModal.open}
              className="bwai-sentiment-modal"
            >
              <ModalHeader
                toggle={() => {
                  setSentimentResponsesModal({
                    open: false,
                    title: "",
                    data: [],
                    loading: false,
                  });
                }}
                className={`sentiment_response_modal_bg ${sentimentResponsesModal.title}`}
              >
        
                {getNeturalMixedTitle(sentimentResponsesModal.title)} Sentiment Responses
              </ModalHeader>
              <ModalBody>
                {sentimentResponsesModal.loading ? (
                  <div className="text-center">
                    Retrieving comments{" "}
                    <img src={Spinner} height="30px" width="30px" />
                  </div>
                ) : (
                  <Table className="sentiments_users_response_table">
                    <thead>
                      <tr>
                        {/* Messaging trivvys drop the first column entirely —
                            the message is the same for all rows and can be
                            very long, so just Comment + %Sentiment per the
                            product call. Surveys keep the Question column. */}
                        {!(currentTrivvy && currentTrivvy.isMessaging) && (
                          <th>{SENTIMENT_MODAL_COLUMN_QUESTION}</th>
                        )}
                        {/* <th>User</th> */}
                        {/* <th>Date</th> */}
                        <th>Comment</th>
                        <th>% {sentimentResponsesModal.title}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sentimentResponsesModal.data.map((result) => {
                        return (
                          <tr>
                            {!(currentTrivvy && currentTrivvy.isMessaging) && (
                              <td>{parse(result.question)}</td>
                            )}
                            {/* <td>
                              {result.user && !result.isAnonymous ? (
                                <span className="trivia_table_text_wrapper">
                                  {profilePicValidityCheck(
                                    result.user.profilePic
                                  ) ? (
                                    <img
                                      src={result.user.profilePic}
                                      height="35px"
                                      width="35px"
                                      style={{ borderRadius: "50%" }}
                                    />
                                  ) :
                                  result.user.identification==='Anonymous'?
                                  (
                                    <span className="spotlightUserInitials">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-1" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="m4.736 1.968-.892 3.269-.014.058C2.113 5.568 1 6.006 1 6.5 1 7.328 4.134 8 8 8s7-.672 7-1.5c0-.494-1.113-.932-2.83-1.205l-.014-.058-.892-3.27c-.146-.533-.698-.849-1.239-.734C9.411 1.363 8.62 1.5 8 1.5s-1.411-.136-2.025-.267c-.541-.115-1.093.2-1.239.735m.015 3.867a.25.25 0 0 1 .274-.224c.9.092 1.91.143 2.975.143a30 30 0 0 0 2.975-.143.25.25 0 0 1 .05.498c-.918.093-1.944.145-3.025.145s-2.107-.052-3.025-.145a.25.25 0 0 1-.224-.274M3.5 10h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5m-1.5.5q.001-.264.085-.5H2a.5.5 0 0 1 0-1h3.5a1.5 1.5 0 0 1 1.488 1.312 3.5 3.5 0 0 1 2.024 0A1.5 1.5 0 0 1 10.5 9H14a.5.5 0 0 1 0 1h-.085q.084.236.085.5v1a2.5 2.5 0 0 1-5 0v-.14l-.21-.07a2.5 2.5 0 0 0-1.58 0l-.21.07v.14a2.5 2.5 0 0 1-5 0zm8.5-.5h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5"/>
                                      </svg>
                                    </span>
                                  ):
                                  (
                                    <span
                                      className="spotlightUserInitials"
                                      data-letters={getInitials(result.user)}
                                    ></span>
                                  )}{" "}
                                  {result.user.identification}{" "}
                                  {result.user.firstName} {result.user.lastName}
                                </span>
                              ) : (
                                <span className="trivia_table_text_wrapper">
                                  <span
                                    className="spotlightUserInitials"
                                    data-letters={"AU"}
                                  ></span>
                                  Anonymous user{" "}
                                  {showYou(user.profile, result) ? "(You)" : ""}
                                </span>
                              )}
                            </td> */}
                            {/* <td>
                              {moment(result.createdOn).format("MMM DD, YYYY")}
                            </td> */}
                            <td>{result.comment}</td>
                            <td>{Math.round((result.score / 1) * 100)}%</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                )}
              </ModalBody>
            </Modal>
          )}
          <div className="multicolor-progress-bar mt-3">
            {segments.map((segment, index) => (
              <div
                key={index}
                className="multicolor-progress-segment cursor-pointer"
                style={{
                  width: `${segment.width}%`,
                  backgroundColor: segment.color,
                }}
                title={`${segment.percentage}%`}
                onClick={() => {
                  if(blockModal !== true){

                    handleGetResponses(segment.name);
                  }
                }}
              ></div>
            ))}
          </div>
          <div className="mt-2 d-flex justify-content-between trivvy-res-insights-sent-scores">
            {segments.map((x, i) => {
              return (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    if(blockModal !== true){
                    handleGetResponses(x.name);
                    }
                  }}
                  style={{
                    fontWeight: "bold",
                    color: x.color,
                  }}
                >
                 {/* {`${x.count} ${getNeturalMixedTitle(x.name)} `} */}
                   <span
                    style={{
                      fontWeight: "bold",
                      color: x.color,
                    }}
                  >
                    <span className="tssco-percent">{x.percentage}%</span>{' '}<span className="tssco-name">{getNeturalMixedTitle(x.name)}</span>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{ textAlign: titleAlign }}
          className="sentiment-analysis-info-popup-container"
        >
          <div className="d-flex mt-3">
            <div className="ml-0 sentiment-analysis sentiment-analysis_positive">
              <BsEmojiSmile />{" "}
              {getSetimentPercent(data["avgPositive"] || data["positive"])}%
            </div>
            <div className="sentiment-analysis sentiment-analysis_neutral">
              <BsEmojiNeutral />{" "}
              {getSetimentPercent(
                (data["avgNeutral"] || 0) + (data["avgMixed"] || 0)
              )}
              %
            </div>
            <div className="sentiment-analysis sentiment-analysis_negative">
              <BsEmojiFrown />{" "}
              {getSetimentPercent(data["avgNegative"] || data["negative"])}%
            </div>
          </div>
        </div>
      );
    }
  } else {
    return (
      <div style={{ textAlign: titleAlign }}>
        <div className="multicolor-progress-bar mt-3">
          <div
            className="multicolor-progress-segment cursor-pointer"
            style={{
              width: `100%`,
              backgroundColor: "#ccc8c8",
            }}
            title={`No sentiment analysis yet`}
          ></div>
        </div>
        <div className="mt-2 text-center">No Sentiments</div>
      </div>
    );
  }
}
